export default class extends HTMLElement {
  connectedCallback () {
    this.querySelectorAll('a').forEach((link) => {
      if (document.location.pathname.startsWith(link.pathname) && !link.getAttribute('href').startsWith('http')) {
        link.setAttribute('aria-current', 'page')
      }

      // Close the mobile settings drawer when a nav link is tapped.
      link.addEventListener('click', () => {
        const toggle = document.getElementById('settings_drawer_toggle')
        if (toggle && toggle.checked) toggle.checked = false
      })
    })
  }
}
